import { UiSchema } from 'prove-common/rjsf'

const subPurposeUiSchema = (purposeName?: string): UiSchema => ({
  subPurposeId: {
    'ui:classNames': 'basis-full max-w-initial',
    'ui:widget': 'SelectWithSubTextWidget',
    'ui:options': {
      undertext: purposeName ? `Hovedhensikt er ${purposeName}` : ''
    }
  }
})

export const createTaskUiSchema: UiSchema = {
  productId: {
    'ui:widget': 'selectProductWidget'
  },
  matrixId: {
    'ui:widget': 'selectMatrixWidget'
  },
  payloadSchemaId: {
    'ui:widget': 'selectPayloadSchemaWidget'
  },
  substanceIds: {
    'ui:widget': 'selectSubstancesWidget'
  },
  description: {
    'ui:widget': 'markdownEditorWidget'
  },
  locationRequired: {
    'ui:role': 'switch'
  },
  countSubSamples: {
    'ui:widget': 'radio'
  }
}

export const getCreateTaskUiSchema = (purposeName?: string): UiSchema => ({
  ...createTaskUiSchema,
  ...subPurposeUiSchema(purposeName)
})

export const editTaskUiSchema: UiSchema = {
  labId: {
    'ui:widget': 'hidden',
    'ui:classNames': 'hidden'
  },
  contractId: {
    'ui:widget': 'hidden',
    'ui:classNames': 'hidden'
  },
  productId: {
    'ui:widget': 'selectProductWidget'
  },
  matrixId: {
    'ui:widget': 'selectMatrixWidget'
  },
  payloadSchemaId: {
    'ui:widget': 'selectPayloadSchemaWidget'
  },
  substanceIds: {
    'ui:widget': 'selectSubstancesWidget'
  },
  description: {
    'ui:widget': 'hidden',
    'ui:classNames': 'hidden'
  },
  locationRequired: {
    'ui:role': 'switch'
  },
  countSubSamples: {
    'ui:widget': 'radio'
  }
}

export const getEditTaskUiSchema = (purposeName?: string): UiSchema => ({
  ...editTaskUiSchema,
  ...subPurposeUiSchema(purposeName)
})
